import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import PrivateLayout from "./PrivateLayout";
import { loginRequest } from "../config/authConfig";
import {
  selectAuthError,
  selectAuthInitialized,
} from "../store/Auth/authSlice";

const PrivateRoute = ({ children }) => {
  const { instance, accounts } = useMsal();
  const authError = useSelector(selectAuthError);
  const authInitialized = useSelector(selectAuthInitialized);
  const authLoading = useSelector((state) => state.auth.loading);
  const basicUser = useSelector((state) => state.auth.user);

  const [isAuthenticated, setIsAuthenticated] = useState(undefined);

  useEffect(() => {
    if (!authInitialized) return;

    if (basicUser) {
      setIsAuthenticated(true);
      return;
    }

    if (accounts.length > 0 && !authError) {
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          setIsAuthenticated(!!response?.accessToken);
        })
        .catch((error) => {
          console.error("❌ MSAL silent token acquisition failed:", error);
          setIsAuthenticated(false);
        });
    } else {
      setIsAuthenticated(false);
    }
  }, [authInitialized, basicUser, instance, accounts, authError]);

  if (!authInitialized || authLoading || isAuthenticated === undefined) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <PrivateLayout>{children}</PrivateLayout>;
};

export default PrivateRoute;
